import { useMemo, useState } from 'react';
import Seo from '@/components/feature/Seo';
import HomeHero from './components/HomeHero';
import HotRank from './components/HotRank';
import CategoryTiles from './components/CategoryTiles';
import Featured from './components/Featured';
import Collections from './components/Collections';
import GuideStrip from './components/GuideStrip';
import Faq from './components/Faq';
import { faqs, hotRankIds, getArticleById, siteName, siteUrl } from '@/mocks/melons';

export default function Home() {
  const [activeCat, setActiveCat] = useState('all');

  const jsonLd = useMemo(() => {
    const topItems = hotRankIds.slice(0, 8)
      .map((h) => getArticleById(h.id))
      .filter(Boolean)
      .map((a) => ({ '@type': 'ListItem', position: hotRankIds.findIndex((h) => h.id === a!.id) + 1, name: a!.title, url: `${siteUrl}/post/${a!.id}` }));
    return [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: siteName,
        url: siteUrl,
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: { '@type': 'EntryPoint', urlTemplate: `${siteUrl}/?q={search_term_string}` },
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: siteName,
        url: siteUrl,
        description: '以瓜田盘点为主线，整理快手吃瓜瓜料、精品瓜与吃瓜合集的图文资讯站。',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: '今日热榜',
        itemListElement: topItems,
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((f) => ({
          '@type': 'Question',
          name: f.q,
          acceptedAnswer: { '@type': 'Answer', text: f.a },
        })),
      },
    ];
  }, []);

  return (
    <>
      <Seo
        title="快手吃瓜 - 快手吃瓜瓜料大全、瓜田盘点与精品瓜汇总"
        description="快手吃瓜瓜料大全集合地，以快手吃瓜瓜田盘点为主线，整理快手吃瓜精品瓜、吃瓜合集与精华总结，让你不用挨个刷动态就能快速补齐必吃瓜，适合想要一次性吃全的吃瓜群众。"
        keywords="快手吃瓜,瓜料大全,瓜田盘点,精品瓜,吃瓜合集"
        canonicalUrl={`${siteUrl}/`}
        type="website"
        jsonLd={jsonLd}
      />
      <HomeHero />
      <HotRank />
      <CategoryTiles activeCat={activeCat} onSelect={setActiveCat} />
      <Featured activeCat={activeCat} setActiveCat={setActiveCat} />
      <Collections />
      <GuideStrip />
      <Faq />
    </>
  );
}